import { T } from "@/lib/i18n";
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Phone, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PHONE_PREFIXES, joinPhone } from "@/lib/phone";
import { API } from "@/lib/api";


// Blocking modal: logged-in clients without phone (e.g. Google sign-up) must add it.
export const PhoneGate = () => {
  const { user, setUser } = useAuth();
  const [prefix, setPrefix] = useState("+41");
  const [num, setNum] = useState("");
  const [busy, setBusy] = useState(false);
  if (!user || user.phone || user.role === "super_admin") return null;
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.put(`${API}/auth/me/phone`, { phone: joinPhone(prefix, num) });
      setUser({ ...user, phone: data.phone });
      toast.success(T("Numero salvato, grazie!"));
    } catch (err) { toast.error(err?.response?.data?.detail || T("Numero non valido")); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="phone-gate" className="fixed inset-0 z-[70] bg-[#09090b]/80 backdrop-blur-sm flex items-center justify-center p-4">
      <form onSubmit={save} className="bg-white w-full max-w-md p-8 space-y-5">
        <div className="w-11 h-11 aurora-gradient flex items-center justify-center"><Phone className="w-5 h-5 text-white" /></div>
        <div>
          <h2 className="font-display text-2xl">{T("Un ultimo passo")}</h2>
          <p className="text-sm text-[#5b6168] mt-1">{T("Inserisci il tuo numero di cellulare: ci serve per contattarti sulle tue campagne.")}</p>
        </div>
        <div className="flex gap-2">
          <select data-testid="phone-gate-prefix" value={prefix} onChange={(e) => setPrefix(e.target.value)}
            className="h-12 border border-[#cfd6d9] bg-white font-mono text-sm px-2">
            {PHONE_PREFIXES.map(([p, c]) => <option key={p} value={p}>{c} {p}</option>)}
          </select>
          <input data-testid="phone-gate-input" type="tel" required minLength={6} value={num} autoFocus
            onChange={(e) => setNum(e.target.value.replace(/[^\d\s]/g, ""))} placeholder={T("es. 79 123 45 67")}
            className="flex-1 h-12 border border-[#cfd6d9] px-3 font-mono text-sm outline-none focus:border-[#2B3036]" />
        </div>
        <button data-testid="phone-gate-submit" disabled={busy}
          className="w-full h-12 aurora-gradient text-white font-medium inline-flex items-center justify-center gap-2 disabled:opacity-50">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Salva e continua
        </button>
      </form>
    </div>
  );
};
